import React from 'react';
import { useLocation } from 'react-router-dom';
import { FiGlobe } from 'react-icons/fi';
import { languages, useLanguage } from '../../context/LanguageContext';
import './LanguageSwitcher.css';

export default function LanguageSwitcher() {
  const { language, setLanguage, t } = useLanguage();
  const location = useLocation();
  const dashboardClass = location.pathname.startsWith('/dashboard') ? ' language-switcher--dashboard' : '';

  return (
    <div className={`language-switcher${dashboardClass}`} aria-label={t('language')}>
      <FiGlobe aria-hidden="true" />
      <select value={language} onChange={(event) => setLanguage(event.target.value)} aria-label={t('language')}>
        {languages.map((item) => <option value={item.code} key={item.code}>{item.short} · {item.label}</option>)}
      </select>
    </div>
  );
}
